import React from "react";
import styles from "./backButton.module.scss";

const BackButton = ({ labelText, handleClick, counter, labelStyle, className, arrowStyle, id }) => {
	const generateCounter = (counter) => {
		if (counter >= 0) {
			return (
				<span className={styles["back-button__counter"]}> ({counter})</span>
			);
		}
		return <span></span>;
	};
	return (
		<div className={`${styles["back-button"]} ${styles[className]}`} onClick={() => handleClick()} id={id}>
			<i className={`${styles["back-button__arrow-left"]} ${styles[arrowStyle]}`}></i>
			<label className={`${styles["back-button__label"]} ${labelStyle} ${styles[labelStyle]}`}>
				{labelText}
			</label>
			{generateCounter(counter)}
		</div>
	);
};

export default BackButton;
